/**
 * @voltxampere/ui — EditNetLabelCommand (Sprint 14)
 *
 * Rename a Net's `name` field. The class name keeps the prompt
 * vocabulary ("net label edit") but the underlying schema field
 * is `name`; SPECS §1.2 already exposes both `name` (identifier)
 * and `label` (display alias). Sprint 14 only edits `name` so a
 * single command covers the inspector input.
 *
 * Validation lives at the call site (inspector input regex,
 * length cap, ground-net guard); this command trusts its inputs.
 *
 * Copyright © 2026 360 Studio
 * Licensed under MIT (see LICENSE file in repo root)
 */
export class EditNetLabelCommand {
    netId;
    oldName;
    newName;
    constructor(netId, oldName, newName) {
        this.netId = netId;
        this.oldName = oldName;
        this.newName = newName;
    }
    do(circuit) {
        return {
            ...circuit,
            nets: circuit.nets.map((n) => (n.id === this.netId ? { ...n, name: this.newName } : n)),
        };
    }
    undo(circuit) {
        return {
            ...circuit,
            nets: circuit.nets.map((n) => (n.id === this.netId ? { ...n, name: this.oldName } : n)),
        };
    }
    describe() {
        return `Net adı: ${this.oldName} → ${this.newName}`;
    }
}
//# sourceMappingURL=edit-net-label.js.map